import { userProfile } from "./UserProfile";

const google_auth_lambda_url = `${process.env.REACT_APP_FT_BACKEND_API_BASE}/auth/google`;

const getHeaders = () => {
  const headers = {
    "x-api-key": process.env.REACT_APP_FT_BACKEND_API_KEY,
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  const jwt = userProfile(localStorage).token();
  if (jwt) headers.Authorization = `Bearer ${jwt}`;

  return headers;
};

const GoogleClient = {
  async accessToken(code) {
    try {
      const response = await fetch(google_auth_lambda_url, {
        method: "POST",
        headers: getHeaders(),
        body: JSON.stringify({
          code: code,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Google auth failed: ${response.status} ${errorText}`);
      }
      return response.json();
    } catch (error) {
      throw error;
    }
  },

   async currentUserInfo(accessToken) {
    try {
      const response = await fetch("https://www.googleapis.com/oauth2/v2/userinfo", {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) throw new Error("Failed to fetch user info");

      return response.json();
    } catch (error) {
      console.error("Google user info error:", error);
      return {};
    }
  },
};

export default GoogleClient;
